// i18n area 'storage' — locale lt-LT (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.lt-LT.meta.json.
import type { enUS } from './storage'

export const ltLT: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Sukurti storage',
      path: 'Kelias',
      pathHint: 'Absoliutus kelias po leidžiama šaknimi (numatytoji /var/lib/tvirt/pools/)',
      shared: 'Bendrinamas storage',
      sharedChip: 'bendrinamas',
      sharedVerifiedChip: 'bendrinamas · patikrintas',
      sharedVerifiedTooltip: 'Bendrinimas patikrintas: kryžminiai zondai patvirtina, kad kiekvienas narys mato kitų įrašytus duomenis.',
      sharedDisputedChip: 'bendrinamas · NEPATIKRINTAS',
      sharedDisputedTooltip: 'Bendrinimas NEPATIKRINTAS',
      sharedDisputedPair: '{observer} nemato duomenų, kuriuos įrašė {writer}',
      sharedHint: 'Tinklo bendrinys, prijungtas vietoje tuo pačiu keliu kiekviename naryje — live migration būtina sąlyga (deklaratyvi).',
      sharedDanger: 'PAVOJUS — TVirt TIKI šia vėliavėle: ją įjungus kiekvienas narys laiko, kad šiame kelyje mato TUOS PAČIUS baitus. Aplanke, kuris NĖRA tikras bendrinys (NFS/CIFS/klasterio failų sistema), rezultatas yra duomenų sugadinimas ir praradimas per pirmą migraciją ar pirmą HA paleidimą kitame mazge. Įjunkite tik tuo atveju, jei kelias yra bendrinys, vienodai prijungtas kiekviename mazge.',
      type: 'Tipas',
      capacity: 'Talpa',
      provisioned: 'Priskirta',
      provisionedOvercommit: 'Galimas įsipareigojimas viršija talpą: thin tomai gali išaugti iki {n} GiB.',
      phase: { ready: 'Parengtas', degraded: 'Degradavęs', error: 'Klaida' },

      // Round #156 (standartinis dialogas): PILNAS išsamios peržiūros dialogas —
      // kortelės, kiekvienos tvarkyklės konfigūracijos eilutės ir stebimas paviršius.
      tabConfig: 'Konfigūracija',
      tabCapacity: 'Talpa ir būsena',
      cardIdentity: 'Tapatybė',
      cardPlacement: 'Išdėstymas',
      cardConnection: 'Ryšys',
      usedReal: 'Tikras užimtumas',
      capacityUnknown: 'Mazgas dar nepranešė šio telkinio talpos — skaičiai čia nėra išgalvojami',
      overcommitHint: 'Priskirta daugiau nei talpa: thin telkiniuose tai teisėta, stebėkite tikrą užimtumą',
      supportedContent: 'Palaikomas turinys',
      content: {
        disks: 'Diskai',
        catalogFiles: 'Katalogo failai',
        backups: 'Atsarginės kopijos',
        appVolumes: 'App tomai'
      },
      defaultDiskFormat: 'Numatytasis disko formatas',
      reserveGiB: 'Rezervuota laisva vieta (GiB)',
      available: 'Laisva',
      diskCount: 'Diskai',
      filesystem: 'Failų sistema',
      observedAt: 'Stebėta',
      lostAtRow: 'Paskelbtas prarastu',
      sharedProbeRow: 'Bendrinimo patikra',
      sharedProbeNodes: 'Zonduoti mazgai',
      reachableFrom: 'Deklaruotas pasiekiamumas',
      reachableFromHint: 'Mazgai, iš kurių šis storage privalo būti pasiekiamas. VM, kurios diskai, ISO ar metaduomenys yra čia, nepasileis ir nemigruos į mazgą, esantį už šio sąrašo ribų. Visi nariai pažymėti iš anksto: siaurinkite, kaip norite. Vėliau į klasterį įstojęs mazgas lieka nuošalyje, kol jo čia nepridėsite.',
      reachableFromNone: 'nedeklaruotas',
      reachableFromTags: 'Pasiekiamumas pagal žymą',
      reachableFromTagsHint: 'Selektorius žyma=reikšmė (įrašai atskiriami kableliais, jungiami AND): kiekvienas narys, turintis šias žymas, laikomas pasiekiamu — dinamiškai: pažymėjus mazgą, jis iškart įtraukiamas.',
      reachableFromTagsInvalid: 'Netinkamas formatas — naudokite žyma=reikšmė, atskirtus kableliais',
      reachableResolved: 'Nustatyti mazgai: {nodes}',
      reachableDeclaredNotSeen: 'deklaruotas, bet bendrinimo zondas jo nepamatė šiuose mazguose: {nodes}',
      reachableSeenNotDeclared: 'pastebėtas, bet nedeklaruotas (už perimetro) šiuose mazguose: {nodes}',
      cephCluster: 'Valdomas Ceph klasteris',
      appGuardTitle: 'Storage naudoja App',
      appEphemeralGuard: 'šis storage yra klasterio App efemerinis telkinys — pirma pakeiskite jį App puslapyje, tik tada šalinkite.',
      appInUseGuard: 'čia gyvena App root ir tomai: {apps} — pirma juos perkelkite arba pašalinkite.',
      releaseRequiredTitle: "Šalinti '{name}' ir atlaisvinti jo atvaizdžius?",
      releaseRequiredBatchTitle: 'Šalinti pasirinktus storage ir atlaisvinti jų atvaizdžius?',
      releaseRequiredBody: 'Atvaizdžių atlaisvinimas neištrina NĖ VIENO baito: išregistravimas palieka namespace diske, atvaizdžiai tiesiog nustoja būti materializuoti, o kiekviena scope nuoroda išlieka kaip claim — vėl užregistravus pool jie vėl įsavinami.',
      releaseConfirm: 'Šalinti ir atlaisvinti atvaizdžius'
    },
    lost: {
      chip: 'Prarastas',
      action: 'Paskelbti prarastu',
      confirmTitle: 'Paskelbti storage prarastu',
      confirmBody: 'Operatoriaus patvirtinimas savo paties deklaruota rizika: kiekvienas eilėje esantis ar vykdomas task šiame storage ar jo objektuose ŽLUGS, šalinimas taps tik registro įrašu (jokio darbo failų sistemoje), o naujas fizinis darbas bus atmetamas. Baitai niekada neliečiami — jei tomas atgis, užregistruokite jį iš naujo ir paleiskite nuskaitymą, kad viskas būtų perimta atgal.',
      confirmSubmit: 'Paskelbti prarastu',
      error: 'Patvirtinimas buvo atmestas'
    },
    findings: {
      action: 'Rasti objektai',
      title: 'Rasti objektai',
      empty: 'Storage namespace nerasta nė vieno objekto',
      loadError: 'Nepavyko įkelti rastų objektų',
      actionError: 'Sprendimas buvo atmestas',
      colKind: 'Tipas',
      colObject: 'Objektas',
      colConflict: 'Konfliktas',
      namespaceNotice:
        'Šis katalogas jau buvo inicijuotas kitos saugyklos: tapatybės antspaudas perrašytas šios saugyklos antspaudu. Turinys NEBUVO liestas — peržiūrėk žemiau rastus objektus, importuok tuos, kurių reikia, ir tada atmesk šį pranešimą.',
      kind: {
        disk: 'Diskas',
        catalogFile: 'Katalogo failas',
        vmMetadata: 'VM metaduomenys',
        namespace: 'Namespace',
        foreign: 'Svetimas',
        volumeGroup: 'Tomų grupė'
      },
      vgAdopt: {
        action: 'Adoptuoti tomų grupę',
        title: 'Adoptuoti tomų grupę',
        intro:
          'Šiame įrenginyje jau yra tomų grupė su TVirt pavadinimu, bet jos antspaudas nenurodo jokio čia registruoto storage. Tai gali būti tai, ką ŠIO klasterio ankstesnis storage paliko LUN, arba tai, ką KITAS TVirt klasteris paliko LUN, pakeitusiame savininką: iš čia abu atvejai atrodo vienodai, ir todėl niekas nesprendžia už tave.',
        irreversible: 'Pažiūrėk į įrenginį, antspaudą ir pavadinimą prieš tęsdamas: adopcijos atšaukti negalima.',
        device: 'Įrenginys',
        seal: 'Antspaudas',
        sealNone: 'nėra (nėra tvirt.storageId žymos)',
        renameTo: 'Bus pervadinta į',
        renameNone: 'Be pervadinimo: pavadinimas jau yra tas, kurį išveda šis storage',
        volumesNote:
          'Jame esantys tomai šiuo veiksmu NĖRA adoptuojami: kitas skenavimas pasiūlys juos po vieną, kaip įprastus rastus objektus.'
      },
      conflictChip: 'ID jau yra',
      dismissedChip: 'Nepaisoma',
      adopt: 'Perimti',
      adoptFileTitle: 'Importuoti į katalogą',
      adoptFileHint: 'Failai gyvuoja tik kataloguose: pasirinkite rastam failui paskirties katalogą.',
      purge: 'Šalinti iš disko',
      dismiss: 'Nepaisyti',
      purgeConfirmTitle: 'Šalinti iš disko',
      purgeConfirmBody: 'Rasti {id} baitai bus pašalinti iš storage. Veiksmas negrįžtamas.',
      taskStarted: 'Pradėta — tęsiama kaip foninis task',
      scan: 'Nuskaityti storage',
      scanStarted: 'Nuskaitymas pradėtas…',
      scanDone: 'Nuskaitymas baigtas — rasti objektai atnaujinti'
    },
    reinit: {
      action: 'Bandyti inicijuoti iš naujo'
    },
    wizard: {
      addButton: 'Pridėti',
      title: 'Pridėti storage',
      back: 'Atgal',
      continue: 'Tęsti',
      selectHint: 'Pasirinkite protokolą, kad pamatytumėte, kaip TVirt jį naudoja.',
      roadmap: 'Planuose',
      server: 'Serveris',
      export: 'Eksportuojamas kelias',
      share: 'Share',
      username: 'Naudotojo vardas',
      password: 'Slaptažodis',
      passwordHint: 'Tik įrašymui: naudojamas prijungiant, daugiau niekada nerodomas.',
      credential: 'Prisijungimo duomenys',
      credentialManual: 'Įvesti rankiniu būdu',
      credentialHint: 'Keystore įrašas su naudotojo vardu ir slaptažodžiu — alternatyva vesti juos čia.',
      credentialEmpty: 'Keystore nėra nė vieno naudotojo vardo ir slaptažodžio įrašo — sukurkite jį skiltyje Sistema → Prisijungimo duomenys arba įveskite paskyrą žemiau.',
      options: 'Prijungimo parinktys',
      optionsHint: 'Atskiriamos kableliais, perduodamos mount -o tokios, kokios yra.',
      portal: 'Portal',
      portalHint: 'hostas[:prievadas] — numatytasis prievadas yra 3260.',
      target: 'Target IQN',
      targetHint: 'iSCSI target vardas, prasideda iqn.',
      lun: 'LUN',
      wholeLunRow: 'Diskuose: ši saugykla įvardija tik target',
      wholeLunHint: 'Ši saugykla įvardija tik target: jos LUN tampa diskais po vieną (Kurti diską → perimti visą LUN), į target niekas nerašoma.',
      lunHint: 'LUN numeris target viduje — abejojant 0.',
      chapCredential: 'Prisijungimo duomenys (CHAP)',
      chapCredentialHint: 'CHAP (iSCSI) tipo keystore įrašas, naudojamas prisijungiant — paslaptis niekada nekeliauja kartu su storage.',
      chapNone: 'Be tapatumo nustatymo',
      chapEmpty: 'Keystore nėra CHAP (iSCSI) tipo prisijungimo duomenų — sukurkite juos skiltyje Sistema → Prisijungimo duomenys. Be jų prisijungimas lieka be tapatumo nustatymo.',
      address: 'Adresas',
      addressHint: 'NVMe/TCP target hostas arba IP (traddr).',
      port: 'Prievadas',
      portHint: 'Target TCP prievadas — 4420, jei paliekama tuščia.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'Subsistemos NQN target pusėje, prasideda nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID subsistemos viduje — abejojant 1.',
      dhchapCredential: 'Prisijungimo duomenys (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'DH-HMAC-CHAP (NVMe) tipo keystore įrašas, naudojamas jungiantis — paslaptis niekada nekeliauja kartu su storage.',
      dhchapNone: 'Be tapatumo nustatymo',
      dhchapEmpty: 'Keystore nėra DH-HMAC-CHAP (NVMe) tipo prisijungimo duomenų — sukurkite juos skiltyje Sistema → Prisijungimo duomenys. Be jų ryšys lieka be tapatumo nustatymo.',
      monitors: 'Monitoriai',
      monitorsHint: 'Ceph monitorių galiniai taškai, hostas[:prievadas], atskirti kableliais arba naujomis eilutėmis — numatytasis prievadas 6789.',
      pool: 'Telkinys',
      poolHint: 'RBD telkinys, kurį naudoti — po vieną RBD atvaizdį kiekvienam diskui.',
      fs: 'Failų sistema',
      fsHint: 'CephFS failų sistemos vardas (mds_namespace prijungiant).',
      fsPath: 'Kelias failų sistemos viduje',
      fsPathHint: 'Absoliutus kelias failų sistemoje, kurį prijungia šis storage — abejojant /.',
      cephxCredential: 'Prisijungimo duomenys (cephx)',
      cephxCredentialHint: 'cephx tipo keystore įrašas: naudotojo vardas = kliento vardas (client.…), paslaptis = base64 raktas. Privaloma.',
      cephxNone: 'Keystore nėra cephx prisijungimo duomenų — sukurkite juos (tipas: cephx) skiltyje Sistema → Prisijungimo duomenys arba leiskite valdomam Ceph klasteriui juos nukalti veiksmu "Siūlyti kaip storage".',
      sharedByNature: 'Tinklo storage yra bendrinami iš prigimties: kiekvienas narys prijungia juos tuo pačiu TVirt valdomu keliu.',
      error: 'Storage buvo atmestas',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Kita',
        legacy: 'Legacy'
      },
      legacyHint: 'Palaikomi visais atžvilgiais — tiesiog naujam diegimui jų nesirinktume.',
      proto: {
        // Eilutė `usage` (Luca 2026-07-24) sako, kaip TVirt naudoja protokolą —
        // pirmiausia leidžiamą turinį: dir/nfs/cifs laiko diskus IR ISO/disko
        // atvaizdžius bei template, blokinės tvarkyklės (iscsi/nvme-tcp/rbd) —
        // TIK diskus.
        dir: {
          name: 'Vietinis aplankas',
          desc: 'Mazgo katalogas: paprasta ir greita. Jis yra VIETINIS viename mazge, nebent kelias yra tikras bendrinys — pažymėti jį bendrinamu, kai jis toks nėra, kainuoja duomenis.',
          usage: 'Čia TVirt laiko VM diskus, ISO/disko atvaizdžius ir template.'
        },
        nfs: {
          name: 'NFS',
          desc: 'Klasterio prijungiamas NFS eksportas — bendrinamas iš prigimties.',
          usage: 'Laiko VM diskus, ISO/disko atvaizdžius ir template.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Klasterio prijungiamas Windows/Samba bendrinys — bendrinamas iš prigimties.',
          usage: 'Laiko VM diskus, ISO/disko atvaizdžius ir template.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Nuotolinė failų sistema per SSH — nereikia jokių NAS eksportų.',
          usage: 'Numatyta planuose.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Blokiniai LUN per IP su bendrinamu LVM viršuje.',
          usage: 'Tik diskai — po vieną thin tomą kiekvienam diskui; nelaiko nei ISO atvaizdžių, nei template.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Blokiniai įrenginiai, paskirstyti Ceph klasteryje.',
          usage: 'Tik diskai — po vieną RBD atvaizdį kiekvienam diskui, natyviai atveriamą iš QEMU; ISO atvaizdžių nelaiko.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Paskirstyta Ceph failų sistema, klasteryje prijungiama branduolio — bendrinama iš prigimties.',
          usage: 'Laiko VM diskus, ISO/disko atvaizdžius ir template — dir šeima ant Ceph failų sistemos (cephx prisijungimo duomenys privalomi).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI LUN per FibreChannel fabric — klasikinis FC SAN.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Tas pats SCSI per FibreChannel, tik FC kadrai įkapsuliuoti į Ethernet.' },

        // Veikia nuo round #132 — raktas yra contract tvarkyklės vardas,
        // todėl storage sąrašo žymuo randa tą patį įrašą.
        'iscsi-lun': {
          name: 'iSCSI (visi LUN)',
          desc: 'iSCSI target kaip visų LUN nešėjas: kiekvienas diskas YRA LUN, perduotas svečiui neapdorotas — be LVM tarp.',
          usage: 'Tik diskai — vienas visas LUN diskui, perimtas toks, koks yra; bendrinamo rašymo diskų SAN namai.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (visi namespace)',
          desc: 'NVMe posistemė kaip visų namespace nešėja: kiekvienas diskas YRA namespace, perduotas svečiui neapdorotas.',
          usage: 'Tik diskai — vienas visas namespace diskui, perimtas toks, koks yra; bendrinamas rašymas taip, SCSI persistent reservations ne.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Nuotolinis NVMe — jokio SCSI kelyje — per paprastą TCP, su bendrinamu LVM viršuje.',
          usage: 'Tik diskai — po vieną thin tomą kiekvienam diskui; nelaiko nei ISO atvaizdžių, nei template.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Nuotolinis NVMe per FibreChannel fabric.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe per FibreChannel fabric, kurį FCoE neša Ethernet viduje — sudėti FCoE ir NVMe/FC sluoksniai.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI su duomenų keliu, perkeltu į RDMA — bet kuris fabric (InfiniBand, iWARP, RoCE). Pralenktas NVMe/RDMA, dar sutinkamas masyvuose ir ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Natyvus SCSI per RDMA, era prieš iSER: InfiniBand (su fabric aptikimu) ir RoCE — išlikęs senstelėjusiose HPC saugyklose.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Nuotolinis NVMe per bet kurį RDMA fabric — InfiniBand, iWARP, RoCE v1 ir v2: viena konfigūracija, o kurį turi — pasako pats mazgas.' },
        s3: { name: 'S3', desc: 'Su S3 suderinamas objektinis storage — atvaizdžiai ir backup.' }
      }
    },
    catalogs: {
      title: 'Katalogai',
      createTitle: 'Sukurti katalogą',
      editTitle: 'Redaguoti katalogą',
      docTitle: 'Katalogas',
      notFound: 'Šio katalogo nėra (nebėra?)',
      scopeHint: 'Kas skaito šį scope, mato (ir gali naudoti) kiekvieną katalogo failą',
      files: 'Failai',
      noFiles: 'Failų nėra',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT tpl',
        vmTemplate: 'VM tpl',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },

      // Sisteminis katalogas (round #126): integruotų platformos objektų namai —
      // visiems skaitomi, niekam nerašomi.
      systemChip: 'sisteminis',
      systemTooltip: 'Sisteminis katalogas: jame gyvena integruoti platformos objektai ir keisti jo negalima'
    },

    // Katalogo failai (round K1, inventory v2e/v2g): katalogas yra klasterio
    // failinių artefaktų namai — vienas sąrašas, pavadinimai pagal kind.
    catalogFiles: {
      catalog: 'Katalogas',
      kindLabel: 'Tipas',
      physicalSize: 'Fizinis dydis',
      virtualSize: 'Virtualus dydis',

      // Round K3 (#64) + K4 (#65, ova/ovf su boot-survival atvaizdavimu):
      // materializuoja vm-template failą kaip inventoriaus VM Template.
      importTemplateAction: 'Importuoti kaip VM Template',
      importTemplateLegacy: 'Formatas nedeklaruotas — tinka kaip diskų pradmuo, bet neimportuojamas',
      importTemplateTitle: 'Importuoti kaip VM Template',
      importTemplateSubmit: 'Importuoti',
      importTemplateError: 'Importas nepavyko',
      importTemplateHint: '.tvtpl paketas tampa VM Template: užšaldyta manifesto aparatinė įranga ir po vieną diską kiekvienam archyvo įrašui, kiekvienas patikrintas pagal savo kontrolinę sumą. NIC ir CD/DVD laikmenos į archyvą neįeina — pridėkite jas po importo.',
      importTemplateQcow2Hint: 'Plikas qcow2 tampa VIENO disko template su deklaruota numatytąja aparatine įranga: linux profilis, UEFI, 2 vCPU, 2048 MiB, įkrova iš vienintelio jo disko. Pataisysite diegdami.',
      importTemplateName: 'Template pavadinimas',
      importTemplateNameHint: 'Tuščia = {name} (-import-<n>, jei užimta)',
      importTemplateStorage: 'Diskų storage',
      importTemplateMetadataStorage: 'Metaduomenų storage',
      importTemplateMetadataHint: 'Blokinis storage nelaiko VM metaduomenų (firmware, varstore) — pasirinkite dir/nfs/cifs.',
      importTemplateStarted: 'Importas pradėtas — template atsiras kortelėje Template, kai task bus baigtas.',

      // Kalbančios etiketės vienaskaitoje (#86): rasti objektai ir surašymas sako,
      // KAS yra failas — bendrinis „Katalogo failas“ lieka tik atsarga.
      kind: {
        iso: 'ISO atvaizdis',
        'ct-rootfs': 'CT rootfs',
        'vm-template': 'VM template',
        'oci-image': 'OCI atvaizdis',
        'firmware-ovmf': 'OVMF firmware'
      },
      title: {
        iso: 'ISO atvaizdžiai',
        'ct-rootfs': 'CT template',
        'vm-template': 'VM template',
        'oci-image': 'OCI atvaizdžiai',
        'firmware-ovmf': 'OVMF firmware'
      },
      createTitle: {
        iso: 'Pridėti ISO atvaizdį',
        'ct-rootfs': 'Registruoti CT template',
        'vm-template': 'Pridėti VM template',
        'oci-image': 'Pridėti OCI atvaizdį',
        'firmware-ovmf': 'Pridėti OVMF firmware'
      },
      formatHint: 'Išvestas iš pasirinkto failo plėtinio — pataisykite, jei atspėta neteisingai',
      tarballHint: 'Rootfs tarball standartiniu LXC formatu (.tar.gz / .tar.xz / .tar.zst / .tar.bz2 arba paprastas .tar)',
      ociArchiveHint: 'docker-archive / oci-archive tarball (.tar arba .tar.gz), pavyzdžiui iš docker save',
      uploadResumeHint: 'Įkėlimas nutrūko — failas laukia įkėlimo: pateikite tą patį failą dar kartą, kad tęstumėte',
      moveTitle: 'Perkelti failą',
      moveHint: 'Du nepriklausomi matmenys: Katalogas perkelia nuorodą (tas pats id, nė vienas baitas nejuda, scope tampa paskirties katalogo scope); Storage perkelia duomenis — kiekviena susieta kopija seka paskui, kol failas naudojamas, veiksmas atmetamas. Pasirinkus abu: pirmiausia katalogas, paskui storage.',
      moveCatalog: 'Paskirties katalogas',
      moveCatalogHint: 'Namus keičia tik nuoroda: failą prijungusi VM turi matyti paskirties katalogą',
      keepCurrent: 'Nekeisti',
      rehomed: 'Nuoroda perkelta į pasirinktą katalogą',
      copyAction: 'Kopijuoti į katalogą…',
      copyTitle: 'Kopijuoti į katalogą',
      copyLinkHint: 'Kopija yra nauja nuoroda į tuos pačius duomenis — storage niekas nedubliuojama.',
      copyCatalog: 'Paskirties katalogas',
      copyCatalogHint: 'Kopija yra būdas failui keliauti tarp katalogų',
      sameCatalog: 'Toks pat kaip šaltinio',
      sharedObjectHint: 'Šio failo duomenimis dalijasi susietų kopijų: {count}',
      deleteLastLink: 'Tai PASKUTINĖ nuoroda į šį turinį: kartu bus pašalinti ir duomenys iš storage.',
      deleteLinkOnly: 'Bus pašalinta tik ši nuoroda — duomenys lieka ir vis dar pasiekiami iš kitų susietų kopijų ({count}).',
      noCatalog: 'Nėra nė vieno katalogo — sukurkite jį',
      inlineCatalogName: 'Katalogo pavadinimas',

      // Į platformą integruoti failai (round #126): storage null — jie
      // skaitomi ir klonuojami, niekada ne move/delete/rename.
      embeddedChip: 'integruotas',
      embeddedStorage: 'Integruota į platformą',
      embeddedNoMove: 'Integruotas platformos failas: jis negyvena jokiame storage — verčiau jį klonuokite',
      embeddedCopyHint: 'Klonas materializuoja integruotus baitus tikrame storage: pasirinkite paskirties storage ir katalogą — kopija yra įprastas failas',
      sourceEmbedded: 'Integruota į platformą',
      nodesRow: 'Buvimas pagal mazgą',
      nodesSummary: '{present} iš {total} mazgų jį turi',
      nodePresent: 'yra',
      nodeMissing: 'trūksta',
      nodeUnknown: 'dar nepranešta',
      nodesHint: 'Išteklius gyvena kiekvieno mazgo diske (paketas trantor-tvirt-assets): mazgas be jo negali nei apibrėžti VM su šia programine aparatine įranga, nei teikti Guest Tools. Skirtingos versijos tarp mazgų yra normalios laipsniško atnaujinimo metu.',

      // Atsisiuntimas (round #108): baitai keliauja su savo atskira teise.
      downloadAction: 'Atsisiųsti',
      downloadNotReady: 'Turinys dar neparengtas — atsisiuntimui reikia parengto failo',
      downloadDenied: 'Jūsų vaidmuo neapima catalog.download — baitų atsisiuntimas yra atskira teisė nuo failo naudojimo',

      // Round #156 (standartinis dialogas): trūkstamos išsamios peržiūros
      // skaitymo eilutės — bendrinamo objekto faktai, deklaruota kontrolinė
      // suma, naudotojai.
      objectRow: 'Storage objektas',
      objectLinksRow: 'Susietos kopijos',
      declaredChecksum: 'Deklaruota SHA-256',
      usedByRow: 'Naudoja',
      usedByVms: 'VM',
      usedByDisks: 'Diskai',
      transferRow: 'Perdavimas',
      storageLockHint: 'Keičiama tik veiksmu Perkelti'
    },

    // Surašymas kiekviename storage (round K1, inventory v2b #2): tik skaitymui,
    // kiekvienas objektas tvarkomas savo skiltyje.
    objects: {
      action: 'Naršyti turinį',
      title: 'Storage turinys',
      hint: 'Tik skaitymui skirtas surašymas, kas gyvena šiame storage — kiekvienas objektas tvarkomas savo skiltyje.',
      empty: 'Šiame storage neužregistruotas nė vienas objektas',
      loadError: 'Nepavyko įkelti turinio',
      colDetail: 'Išsamiau',
      manage: 'Tvarkyti jo skiltyje',
      kind: {
        disk: 'Diskas',
        catalogFile: 'Katalogo failas',
        ociBlob: 'OCI blobas',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM metaduomenys',
        appRoot: 'App root',
        appVolume: 'App tomas'
      }
    },
    inventory: {
      tabCatalogs: 'Katalogai',
      storage: 'Storage',
      sizeGib: 'Dydis (GiB)',
      format: 'Formatas',
      size: 'Dydis',
      sourceType: 'Šaltinis',
      sourceFile: 'Failo įkėlimas',
      sourceUrl: 'Atsisiuntimas iš URL',
      file: 'Failas',
      url: 'URL',
      checksum: 'SHA-256 kontrolinė suma',
      checksumHint: 'Privaloma: atsisiuntimas tikrinamas pagal šią SHA-256',
      verifyChecksum: 'Tikrinti kontrolinę sumą',
      checksumOffHint: 'Atsisiuntimas bus priimtas be patikros — apskaičiuota SHA-256 vis tiek įrašoma',
      uploading: 'Įkeliama…',
      move: {
        action: 'Perkelti',
        diskTitle: 'Perkelti diską',
        target: 'Paskirties storage',
        diskHint: 'Diskas išsaugo savo tapatybę: baitai keliauja į pasirinktą storage. Jį naudojanti VM turi būti išjungta; esant snapshot, iSCSI pusė perkėlimą atmeta.',
        noTargets: 'Nėra suderinamo paskirties storage',
        submit: 'Perkelti',
        error: 'Perkėlimas buvo atmestas'
      },
      clone: {
        action: 'Klonuoti',
        title: 'Klonuoti diską',
        name: 'Kopijos pavadinimas',
        storage: 'Paskirties storage',
        sameStorage: 'Toks pat kaip šaltinio',
        linked: 'Linked clone',
        linkedHint: 'Akimirksniu sukuriamas qcow2 overlay, sujungtas su šaltinio disku (tik qcow2 šaltiniams). Numatytoji yra pilna kopija.',
        linkedCrossHint: 'Linked clone lieka šaltinio storage: kad jį įjungtumėte, pasirinkite "Toks pat kaip šaltinio".',
        submit: 'Klonuoti',
        error: 'Klonavimas buvo atmestas'
      },
      copy: {
        action: 'Kopijuoti',
        name: 'Kopijos pavadinimas',
        storage: 'Paskirties storage',
        sameStorage: 'Toks pat kaip šaltinio',
        submit: 'Kopijuoti',
        error: 'Kopijavimas buvo atmestas'
      },
      taskStarted: 'Pradėta — tęsiama kaip foninis task',
      cephObjects: 'Peržiūrėti objekto duomenis Ceph',
      phase: {
        ready: 'Parengta',
        creating: 'Kuriama',
        'awaiting-upload': 'Laukiama įkėlimo',
        downloading: 'Atsisiunčiama',
        verifying: 'Tikrinama',
        deleting: 'Šalinama',
        error: 'Klaida',
        'in-use': 'Naudojama'
      }
    }
  }
}
